// src/config.js

/**const config = {
  API_URL: "http://127.0.0.1:8000",
  APP_URL: "http://127.0.0.1:3000",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};

/**
const config = {
  API_URL: "https://admins.junisaproducts.com",
  APP_URL: "https://admins.junisaproducts.com/admin/payroll_",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};
const config = {
  API_URL: "https://finance.joharischool.co.ke/shule/public",
  APP_URL: "https://finance.joharischool.co.ke",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};

**/

const config = {
  API_URL: "https://cms.junisaproducts.com/cms/public",
  BASE_COLOR:'#e65c00',
  APP_URL: "https://cms.junisaproducts.com",
  FONT_FAMILY:'Quicksand',
};
/**
const config = {
  API_URL: "https://salesapp.infinitivelogic.com",
  APP_URL: "https://salesapp.infinitivelogic.com/salesapp",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};


**/



export default config;
